'use strict';

module Dashboard {

    class DashboardBookingItinerary {
        template: string;
        bookingTitle: string;
        itineraries: any;
        bookingType: number;
        bookingTypes: any;
        hotelData: any;
        insuranceProvider: string;
        itineraryType: {[key:string]:number};
        expandable: boolean;
        fallbackEn: boolean;

        templateMap:{[key:number]:string} = {
            1: 'flight',
            2: 'tickets',
            4: 'car-hire',
            8: 'accommodation',
            9: 'holiday',
            16: 'parking',
            32: 'transfer',
            64: 'insurance',
            128: 'package-holidays',
            256: 'marhaba',
            1024: 'bundle',
            2048: 'adhoc'
        };

        productsMap:{[key:number]:string} = {
            1: 'Flight',
            8: 'Accommodation',
            32: 'Transfer',
            256: 'Ground Handling',
            2048: 'Adhoc'
        };
        isMobile: boolean;

        constructor(
            private imageService,
            private dashboardBookingService,
            private dateUtil,
            private resourceService: Core.ResourceService,
            private brandedFareTypesService: ekh.BrandedFareTypesService,
        ) {
            this.isMobile = TRPCONFIG.IsMobileDevice;
            this.template = this.templateMap[this.bookingType];
            this.bookingTypes = dashboardBookingService.getBookingTypeMap();
            this.itineraryType = dashboardBookingService.getItineraryType();
            this.expandable = TRPCONFIG.Domain.MYBProductsDetailsExpanded;

            if (this.bookingType === this.bookingTypes.travelInsurance) {
                this.insuranceProvider = this.bookingTitle.split(':')[0];
            }
        }

        getResourceValue(resource:string):string {
            return this.resourceService.get(resource);
        }

        filterTransfer(itinerary:any):boolean {
            return itinerary.Type === this.itineraryType['TransferArrival'] ||
                itinerary.Type === this.itineraryType['TransferReturn'];
        }

        getImage(estabId:number):string {
            return this.imageService.getImageUrl(estabId, 180, 180, 1);
        }

        getAcommImage(estabId:number):string {
            return this.imageService.getMainImageUrl(estabId, 370, 370);
        }

        getContentUrl() {
            return 'partials/dashboard/ItineraryTemplate?Type=' + this.template;
        }

        getNights(start, end) {
            return this.dateUtil.numberOfNights(start, end);
        }

        public getBookingClassName(fc) {
            return this.brandedFareTypesService.getBookingClassName(fc);
        }

        public getClassName(fc) {
            const fareName = this.brandedFareTypesService.getClassName(fc);
            const type = this.brandedFareTypesService._getTransformedType(fareName);
            return this.brandedFareTypesService._setClassName(type);
        }

        getTitle(id) {
            if (this.hotelData && this.hotelData[0][id] && this.hotelData[0][id].EstabTitle) {
                return this.hotelData[0][id].EstabTitle;
            }
        }

        getAddress(id) {
            if (this.hotelData && this.hotelData[0][id] && this.hotelData[0][id].Address) {
                return this.hotelData[0][id].Address;
            }
        }
    }

    angular
        .module('dashboard')
        .component('dashboardBookingItinerary', {
            bindings: {
                bookingTitle: '=',
                itineraries: '=',
                bookingType: '=',
                hotelData: '=',
                fallbackEn: '='
            },
            controller: DashboardBookingItinerary,
            controllerAs: 'bi',
            template: '<expander ng-if="bi.bookingType !== 1024 && bi.isMobile" '+
            'data-title="{{bi.productsMap[bi.bookingType]}}" expanded="bi.expandable" accordion="true"'+
            ' header-class="expander-header important-info-details" body-class="expander-body">' +
            '<div ng-include="bi.getContentUrl()"></div>' + '</expander>' +
            '<div ng-if="!bi.isMobile" ng-include="bi.getContentUrl()"></div>'
        });
}
